module.exports = __webpack_public_path__ + "e4de912.v5.0.7.woff2";